import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { inquiriesApi } from '../../../api/adminApi';
import './InquiryList.css';

const DEFAULT_LIMIT = 10;

function InquiryList() {
  const [inquiries, setInquiries] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(DEFAULT_LIMIT);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadInquiries = (pageNum = page) => {
    setLoading(true);
    setError('');
    inquiriesApi
      .list(pageNum, limit)
      .then((res) => {
        setInquiries(res.list);
        setTotal(res.total);
        setPage(res.page);
      })
      .catch((err) => setError(err.userMessage || 'Failed to load inquiries'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadInquiries(1);
  }, []);

  const inquiryParent = (i) => i.parent_name ?? i.name ?? i.full_name ?? i.sender_name ?? '—';
  const inquiryChild = (i) => {
    const name = i.child_name ?? '';
    const age = i.child_age;
    if (name && age != null) return `${name} (age ${age})`;
    return name || (age != null ? `Age ${age}` : '—');
  };
  const inquiryEmail = (i) => i.email ?? i.sender_email ?? '—';
  const inquiryPreview = (i) => {
    const msg = i.message ?? i.body ?? i.content ?? '';
    return (msg || '').slice(0, 60) + ((msg || '').length > 60 ? '…' : '') || '—';
  };
  const inquiryDate = (i) => {
    const str = i.created_at ?? i.createdAt ?? i.date ?? '';
    if (!str) return '—';
    try {
      const d = new Date(str);
      return isNaN(d.getTime()) ? str : d.toLocaleDateString(undefined, { dateStyle: 'short' });
    } catch {
      return str;
    }
  };
  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div className="admin-inquiries">
      <div className="admin-inquiries-header">
        <h2>Inquiry Messages</h2>
      </div>

      {error && (
        <div className="admin-inquiries-error" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="admin-inquiries-loading">Loading inquiries…</div>
      ) : (
        <div className="admin-inquiries-table-wrap">
          <table className="admin-inquiries-table">
            <thead>
              <tr>
                <th>Parent</th>
                <th>Child</th>
                <th>Email</th>
                <th>Message</th>
                <th>Date</th>
                <th className="admin-inquiries-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.length === 0 ? (
                <tr>
                  <td colSpan={6} className="admin-inquiries-empty">
                    No inquiries yet.
                  </td>
                </tr>
              ) : (
                inquiries.map((i) => (
                  <tr key={i.id}>
                    <td>{inquiryParent(i)}</td>
                    <td>{inquiryChild(i)}</td>
                    <td>{inquiryEmail(i)}</td>
                    <td className="admin-inquiries-message">{inquiryPreview(i)}</td>
                    <td>{inquiryDate(i)}</td>
                    <td className="admin-inquiries-actions">
                      <Link to={`/admin/inquiries/${i.id}`} className="admin-inquiries-btn admin-inquiries-btn-view">
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {!loading && total > 0 && totalPages > 1 && (
        <div className="admin-inquiries-pagination">
          <button
            type="button"
            className="admin-inquiries-page-btn"
            onClick={() => loadInquiries(page - 1)}
            disabled={page <= 1}
          >
            Previous
          </button>
          <span className="admin-inquiries-page-info">
            Page {page} of {totalPages} ({total} total)
          </span>
          <button
            type="button"
            className="admin-inquiries-page-btn"
            onClick={() => loadInquiries(page + 1)}
            disabled={page >= totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default InquiryList;
